<template>
  <div class="secure-section" :class="{ [className]: className }">
    <p class="title">
      Safe and Secure checkout
    </p>
    <div class="secure-icons">
      <IconNortonSecured class="icon-norton-secured" />
      <IconSecureStripe />
      <IconSecurePaypal />
    </div>
  </div>
</template>

<script>
import IconSecureStripe from '../../assets/svg/icon-secure-stripe.svg?vue-component';
import IconSecurePaypal from '../../assets/svg/icon-secure-paypal.svg?vue-component';
import IconNortonSecured from '../../assets/svg/icon-norton-secured.svg?vue-component';

export default {
  components: {
    IconSecureStripe,
    IconSecurePaypal,
    IconNortonSecured,
  },
  props: {
    title: {
      type: String,
      default: 'Safe and Secure checkout',
    },
    className: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.secure-section {
  .title {
    margin-top: var(--spacing-24);
    margin-bottom: var(--spacing-14);
  }

  .secure-icons {
    display: flex;
    align-items: center;
    gap: var(--spacing-14);

    svg {
      flex: 0 0 auto;

      &.icon-norton-secured {
        width: 95px;
        height: 40px;
      }
    }
  }

  &.mobile {
    display: none;
  }
}

@include bp($bp-mobile) {
  .secure-section.mobile {
    display: block;
    margin-top: var(--spacing-40);
    margin-bottom: var(--spacing-40);

    .title {
      margin-top: 0;
      text-align: center;
    }

    .secure-icons {
      justify-content: center;
    }
  }
}
</style>
